import React, { FC } from 'react';

import { Element, useSvgColor, Svg } from '~/assets/icons/styles';
import { OneColorIconProps } from '~/assets/icons/types';

const PathwaySmallIcon: FC<OneColorIconProps> = ({ color, ...props }) => {
  const svgColor = useSvgColor(color);

  return (
    <Svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
      svgColor={svgColor}
    >
      <Element d="M14,12h4a4.02913,4.02913,0,0,1,4,4,4.01176,4.01176,0,0,1-4,4" />
      <Element d="M10,4h8" />
      <Element d="M6,4A4.01176,4.01176,0,0,0,2,8a4.02913,4.02913,0,0,0,4,4h4" />
      <Element as="line" x1="14" y1="20" x2="6" y2="20" />
      <Element as="circle" cx="8" cy="4" r="2" />
      <Element as="circle" cx="4" cy="20" r="2" />
      <Element as="circle" cx="16" cy="20" r="2" />
      <Element as="circle" cx="20" cy="4" r="2" />
      <Element as="circle" cx="12" cy="12" r="2" />
    </Svg>
  );
};

export default PathwaySmallIcon;
